import headQuarters from '../../utils/collections/hq';
import {isNullOrEmptyArray} from "../../utils/general";

const availableFilters = (isvOwners) => {
	const arr = [
		{ label: 'HQ', key: 'End_Customer_HQ__c', type: 'list', values: headQuarters},
		{ label: 'Region', key: 'End_Customer_Region__c', type: 'list', values: ["EMEA", "US & Canada", "Latam", "APAC"]},
		{ label: 'Customer Status', key: 'Customer_Status__c', type: 'list', values: ["Pending", "Approved", "Declined", "Channel Conflict", "In Contact With", "Already a Customer"]},
		{ label: 'Opportunity Heat', key: 'Opportunity_Heat__c', type: 'list', values: ["Standard", "Hot"]},
		{ label: 'Stage', key: 'StageName', type: 'list', values: [
				"Cloud Engagement",
				"Closed Lost",
				"Closed Won",
				"Customer Engagement",
				"Customer Intro",
				"Customer Meeting",
				"Negotiation/Review",
				"Outreach",
				"POV",
				"Prospect",
				"Proposal/Price Quote",
				"Qualification"
			]},
		{ label: 'Last Stage Change Date Internal', key: 'Last_Stage_Change_Date_internal__c', type: 'date' },
		// { label: 'Leading Cloud', key: '', type: 'list', values: ["AWS", "Microsoft", "GCP"]},
		// { label: 'Cloud Portal Sync', key: 'End_Customer_HQ__c', type: 'text', }
	];

	if(!isNullOrEmptyArray(isvOwners)) {
		arr.push(
			{ label: 'ISV Opportunity Owner', key: 'ISV_Opportunity_Owner__r.Name', type: 'list', values: isvOwners},
		);
	}

	return arr;
};

export default availableFilters;
